/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Caption_Name_RequiredInputs */

const en_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File name cannot be empty`)
};

const fr_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom du fichier ne peut pas être vide`)
};

const de_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Dateiname darf nicht leer sein.`)
};

const it_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nome del file non può essere vuoto`)
};

const ru_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя файла не может быть пустым.`)
};

const es_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El nombre del archivo no puede estar vacío`)
};

const zh_cn2_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件名不能为空。`)
};

const ja_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル名は空にできません`)
};

const hi_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल का नाम खाली नहीं हो सकता`)
};

const pt_pt2_ateliere_connect_caption_name_required = /** @type {(inputs: Ateliere_Connect_Caption_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome do arquivo não pode estar vazio.`)
};

/**
* | output |
* | --- |
* | "File name cannot be empty" |
*
* @param {Ateliere_Connect_Caption_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_caption_name_required = /** @type {((inputs?: Ateliere_Connect_Caption_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Caption_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_caption_name_required(inputs)
	if (locale === "de") return de_ateliere_connect_caption_name_required(inputs)
	if (locale === "it") return it_ateliere_connect_caption_name_required(inputs)
	if (locale === "ru") return ru_ateliere_connect_caption_name_required(inputs)
	if (locale === "es") return es_ateliere_connect_caption_name_required(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_caption_name_required(inputs)
	if (locale === "ja") return ja_ateliere_connect_caption_name_required(inputs)
	if (locale === "hi") return hi_ateliere_connect_caption_name_required(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_caption_name_required(inputs)
	return en_ateliere_connect_caption_name_required(inputs)
});